var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',[_c('VCol',{attrs:{"cols":"12","md":"10","lg":"5"}},[(_vm.integrationDataLoading)?_c('Preloader'):_vm._e(),(_vm.integrations.length && !_vm.integrationDataLoading)?_c('VacancyIntegrationsList'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }